import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import Image from '../../atoms/Image';
import PagiNation from '../../molecules/PagiNation/PagiNation';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

export default function Table(props) {
  const { rows, headers, onClickRow } = props;
  const classes = useStyles();
  const [rowList, setRowList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchData, setSearchData] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const rowsPerPage = 10;
  const [headerWidth, setHeaderWidth] = useState({ first: 60, second: 40 });

  useEffect(() => {
    const headerNoAndTitleWidth = headers.filter((h) => h.value === 'no' || h.value === 'title');
    let headerFirstWidth = 0;
    for (const h of headerNoAndTitleWidth) {
      headerFirstWidth += h.width;
    }
    setHeaderWidth({
      first: headerFirstWidth,
      second: 100 - headerFirstWidth,
    });

    const sortedRows = rows.sort((a, b) => {
      if (a.date > b.date) {
        return -1;
      } else {
        return 1;
      }
    });
    const addNumberRows = sortedRows.map((r, i) => {
      return { ...r, no: rows.length - i };
    });

    const filteredRows = addNumberRows.filter((r) => r.title.toUpperCase().includes(searchData.toUpperCase()));
    setTotalCount(filteredRows.length);
    const currentRows = filteredRows.filter((s, i) => i < currentPage * rowsPerPage && i >= currentPage * rowsPerPage - rowsPerPage);

    setRowList(currentRows);
  }, [rows, currentPage, searchData]);

  const paginate = (n) => {
    setCurrentPage(n);
  };

  const prevClick = () => {
    setCurrentPage(currentPage - 1);
  };

  const nextClick = () => {
    setCurrentPage(currentPage + 1);
  };

  const prevPageClick = () => {
    let x = Math.ceil(currentPage / 5) - 1;
    let y = x - 1;
    const z = 1;

    if (Math.ceil(currentPage / 5) === 1) {
      setCurrentPage(1);
    } else setCurrentPage(y * 5 + z);
  };

  const nextPageClick = () => {
    let x = Math.ceil(currentPage / 5) + 1;
    let y = x - 1;
    const z = 1;

    if (Math.ceil(rows.length / rowsPerPage / 5) === Math.ceil(currentPage / 5)) {
      return;
    } else setCurrentPage(y * 5 + z);
  };

  const handleSearch = (e) => {
    setCurrentPage(1);
    setSearchData(e.target.value);
  };

  const handleSearchIcon = () => {
    document.querySelector('#searchInput').focus();
  };
  const handleClearIcon = () => {
    setSearchData('');
    document.querySelector('#searchInput').focus();
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.searchBox}>
        <Box className={classes.searchInner}>
          <input id='searchInput' className={classes.search} type='text' value={searchData} onChange={handleSearch} />
          <SearchIcon onClick={handleSearchIcon} sx={{ fontSize: 24 }} className={`${classes.searchIcon} searchIcon`} />
          {!!searchData && <ClearIcon onClick={handleClearIcon} sx={{ fontSize: 12 }} className={`${classes.clearIcon} clearIcon`} />}
        </Box>
      </Box>
      <Box className={classes.tableBox}>
        <Box className={classes.headerBox}>
          {headers.map((h, i) => {
            return (
              <Box className={classes.header} key={i} style={{ width: `${h.width}%` }}>
                {h.name}
              </Box>
            );
          })}
        </Box>
        <Box className={classes.mHeaderBox}>
          <Box className={classes.mHeader}>A total of {totalCount} articles</Box>
        </Box>
        <Box className={classes.rowBox}>
          {rowList.map((r, i) => {
            return (
              <Box key={i} className={classes.row}>
                <Box className={classes.rowBox1} style={{ width: `${headerWidth.first}%` }}>
                  {headers.map((h, j) => {
                    if (h.value === 'title' || h.value === 'no') {
                      return (
                        <Box
                          key={j}
                          className={`${classes.rowData} ${h.value} ${h.value === 'title' && classes.rowTitle}`}
                          style={{ width: `${(h.width / headerWidth.first) * 100}%` }}
                          onClick={h.value === 'title' ? onClickRow.bind(this, r) : () => {}}
                        >
                          {r[h.value]}
                        </Box>
                      );
                    } else {
                      return '';
                    }
                  })}
                </Box>
                <Box className={classes.rowBox2} style={{ width: `${headerWidth.second}%` }}>
                  {headers.map((h, j) => {
                    if (h.value === 'file') {
                      return (
                        <Box key={j} className={`${classes.rowData} ${h.value}`} style={{ width: `${(h.width / headerWidth.second) * 100}%` }}>
                          {r[h.value].length !== 0 && <Image src='/images/icon/file icon.png' alt='Notice File Icon' />}
                        </Box>
                      );
                    } else if (h.value !== 'title' && h.value !== 'no')
                      return (
                        <Box key={j} className={`${classes.rowData} ${h.value}`} style={{ width: `${(h.width / headerWidth.second) * 100}%` }}>
                          {h.value === 'date' ? r[h.value].slice(2) : r[h.value]}
                        </Box>
                      );
                    else return '';
                  })}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
      <Box className={classes.paginationBox}>
        <PagiNation
          postsPerPage={rowsPerPage}
          totalPosts={totalCount === 0 ? 1 : totalCount}
          currentNum={currentPage}
          paginate={paginate}
          nextClick={nextClick}
          prevClick={prevClick}
          nextPageClick={nextPageClick}
          prevPageClick={prevPageClick}
        />
      </Box>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  // 검색
  searchBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '16px',
  },
  searchInner: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    '&:focus-within': {
      '& svg.searchIcon': {
        color: 'rgb(46,105,155)',
      },
    },
  },
  search: {
    border: '0',
    borderBottom: '1px solid',
    height: '32px',
    padding: '0 32px',
    boxSizing: 'border-box',
    outline: 0,
    borderRadius: 0,
    '&:focus-visible': {
      outline: '0',
    },
    width: '240px',
    fontSize: '16px',
    '&:focus': {
      // borderColor: 'rgb(46,105,155)',
      borderBottom: '3px solid rgb(46,105,155)',
    },
  },
  searchIcon: {
    position: 'absolute',
    color: theme.color.black,
  },
  clearIcon: {
    position: 'absolute',
    color: theme.color.black,
    right: 0,
    backgroundColor: '#00000020',
    borderRadius: '50%',
    padding: '2px',
  },
  // 테이블
  tableBox: {},
  headerBox: {
    display: 'flex',
    width: '100%',
    '@media only screen and (max-width: 768px)': {
      display: 'none',
    },
  },
  header: {
    backgroundColor: '#f4f6f9',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    padding: '16px 16px',
    boxSizing: 'border-box',
    fontSize: '18px',
    color: '#5a5a5a',
  },
  mHeaderBox: {
    width: '100%',
    display: 'none',
    '@media only screen and (max-width: 768px)': {
      display: 'flex',
    },
  },
  mHeader: {
    backgroundColor: '#f4f6f9',
    width: '100%',
    justifyContent: 'center',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    padding: '16px 16px',
    boxSizing: 'border-box',
    fontSize: '16px',
    color: '#5a5a5a',
  },
  rowBox: {},

  row: {
    display: 'flex',
    width: '100%',
    borderBottom: '1px solid #cecece',
    alignItems: 'center',
    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  rowBox1: {
    display: 'flex',

    '@media only screen and (max-width: 768px)': {
      width: '100% !important',
    },
  },
  rowBox2: {
    display: 'flex',

    '@media only screen and (max-width: 768px)': {
      width: '100% !important',
      '& :last-child': {
        borderLeft: '2px solid #00000030',
      },
    },
  },
  rowData: {
    padding: '16px 16px',
    boxSizing: 'border-box',
    fontSize: '18px',
    color: '#191919',

    '@media only screen and (max-width: 768px)': {
      display: 'none',
      '&.title, &.writer, &.date': {
        display: 'block',
      },
      '&.writer, &.date': {
        width: 'fit-content !important',
        padding: '0 16px',
        marginBottom: '16px',
        color: '#00000080',
        fontSize: '12px',
      },
    },
  },
  rowTitle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '&:hover': {
      color: '#0062AC',
      textDecoration: 'underline',
    },
    '@media only screen and (max-width: 768px)': {
      width: '100% !important',
    },
  },
  // 페이지네이션
  paginationBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
